/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

document.addEventListener("DOMContentLoaded", () => {
    const slider = document.querySelector('.video-carousel .splide');

    if( slider ) {
        var splide = new Splide( '.video-carousel .splide' , {
            type: 'slide',
            rewind: true,
            speed: 1000,
            arrows: false,
            pagination: false,
            perPage: 2,
            perMove: 1,
            padding: {
                right: '5%'
            },
            gap: '1%',
            breakpoints: {
                960: {
                    perPage: 1,
                    padding: {
                        right: '10%'
                    },
                },
            }
        });
        splide.mount();
    }
});